import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee315bee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rocket" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = { class: "font-semibold text-xl select-none" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-end mt-6"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_step_company = _resolveComponent("step-company")!
  const _component_step_city = _resolveComponent("step-city")!
  const _component_step_senders = _resolveComponent("step-senders")!
  const _component_step_receivers_express = _resolveComponent("step-receivers-express")!
  const _component_step_products = _resolveComponent("step-products")!
  const _component_products_list = _resolveComponent("products-list")!
  const _component_step_additional_data = _resolveComponent("step-additional-data")!
  const _component_step_tariffs = _resolveComponent("step-tariffs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Доставка за 3 часа" }),
      _createVNode(_component_the_button, {
        class: "second text small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_step_company, {
      class: "mt-6",
      "step-number": 1,
      disabled: _ctx.isActionsDisabled,
      "company-id": _ctx.state.company_id,
      onSubmit: _ctx.onCompanySubmit,
      onReset: _ctx.onCompanyReset
    }, null, 8, ["disabled", "company-id", "onSubmit", "onReset"]),
    _createVNode(_component_step_city, {
      class: "mt-6",
      "step-number": 2,
      opened: _ctx.isCompanySelected,
      disabled: _ctx.isActionsDisabled,
      onSubmit: _ctx.onCitySubmit,
      onReset: _ctx.onCityReset
    }, null, 8, ["opened", "disabled", "onSubmit", "onReset"]),
    _createVNode(_component_step_senders, {
      class: "mt-6",
      "step-number": 3,
      opened: _ctx.isCitySelected && _ctx.isCompanySelected,
      "company-id": _ctx.state.company_id,
      "city-id": _ctx.state.city_id,
      disabled: _ctx.isActionsDisabled,
      "is-express": "",
      onSubmit: _ctx.onSenderSubmit,
      onReset: _ctx.onSenderReset
    }, null, 8, ["opened", "company-id", "city-id", "disabled", "onSubmit", "onReset"]),
    _createVNode(_component_step_receivers_express, {
      class: "mt-6",
      "step-number": 4,
      opened: _ctx.isCitySelected && _ctx.isCompanySelected,
      "company-id": _ctx.state.company_id,
      "city-id": _ctx.state.city_id,
      receivers: _ctx.state.receivers,
      disabled: _ctx.isActionsDisabled,
      onSubmit: _ctx.onReceiverSubmit,
      onReset: _ctx.onReceiverReset
    }, null, 8, ["opened", "company-id", "city-id", "receivers", "disabled", "onSubmit", "onReset"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.receivers, (receiver, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `receiver-info-${idx}`,
        class: "mt-6 px-6 py-4 bg-white border"
      }, [
        _createElementVNode("p", _hoisted_4, "Накладная №" + _toDisplayString(idx + 1), 1),
        _createElementVNode("p", null, "Получатель: " + _toDisplayString(receiver.title), 1),
        _createVNode(_component_step_products, {
          class: "mt-6",
          "receiver-idx": idx,
          disabled: _ctx.isActionsDisabled,
          onSubmit: _ctx.onAddProduct
        }, null, 8, ["receiver-idx", "disabled", "onSubmit"]),
        (_ctx.state.receivers[idx].items.length)
          ? (_openBlock(), _createBlock(_component_products_list, {
              key: 0,
              class: _normalizeClass({ 'mt-3': _ctx.isCanCreateOrder, 'mt-6': !_ctx.isCanCreateOrder }),
              products: _ctx.state.receivers[idx].items,
              disabled: _ctx.isActionsDisabled,
              "receiver-idx": idx,
              onRemove: _ctx.onRemoveProduct
            }, null, 8, ["class", "products", "disabled", "receiver-idx", "onRemove"]))
          : _createCommentVNode("", true),
        _createVNode(_component_step_additional_data, {
          class: "mt-6",
          disabled: _ctx.isActionsDisabled,
          opened: _ctx.isSenderSelected && _ctx.isReceiverSelected,
          "receiver-idx": idx,
          onSubmit: _ctx.onAdditionalDataSubmit,
          onReset: _ctx.onAdditionalDataReset
        }, null, 8, ["disabled", "opened", "receiver-idx", "onSubmit", "onReset"])
      ]))
    }), 128)),
    _createVNode(_component_step_tariffs, {
      class: "mt-6",
      "step-number": 5,
      opened: _ctx.isSenderSelected && _ctx.isReceiverSelected,
      disabled: _ctx.isActionsDisabled,
      points: _ctx.state.points,
      onSubmit: _ctx.onTariffSubmit,
      onReset: _ctx.onTariffReset
    }, null, 8, ["opened", "disabled", "points", "onSubmit", "onReset"]),
    (_ctx.isCanCreateOrder)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_the_button, {
            class: "primary small",
            loading: _ctx.state.is_creating_order,
            onClick: _ctx.createExpressOrder
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode(" Создать заказ ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}